import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";

export default function App() {
  return (
    <div className="appShell">
      <Header />
      <main className="mainContent">
        <Home />
      </main>
      <Footer />
    </div>
  );
}
